import React from "react";
import $ from 'jquery';
import Stock from '../services/stock';
import AuthorizationCheck from '../auth/authorizationCheck';
import { Button } from "bootstrap";
import Utility from "../utilities/utility";

class StockProductProductTransactions extends React.Component {


    constructor() {

        super();

        this.stockService = new Stock();

        this.state = {
            productList: [],
            currentUserRole: '',
        }
    }

    componentDidMount() {

        this.products();
    }

    setRole = (role) => {

        this.setState({ currentUserRole: role });
    }

    products = async () => {

        let name = $('#name').val();
        let model = $('#model').val();
        let brand = $('#brand').val();
        let size = $('#size').val();
        

        try {
            const response = await this.stockService.transactionList(name, model, brand, size, '');

            this.setState({ 
                productList: await response.json() 
            });


        } catch (error) {
            console.log(error)
        }



    }



    render() {


        const productList = this.state.productList;
        let index = 0;

        return (


            <div className="container">

                <AuthorizationCheck accessLevel='MANAGER' userRole={this.setRole} />

                <div className="supplier-wrapper mt-4">

                    <h2 className="text-center">List de Produits</h2>


                    <div className="form-wrapper">
                        <div className="row">
                            <div className="col">


                                <div className="form-group">
                                    <input className="form-control" id="name" placeholder="Nom" />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="model" placeholder="Model" />
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col">

                                <div className="form-group">
                                    <input className="form-control" id="brand" placeholder="Marque" />
                                </div>
                            </div>
                            <div className="col">
                                <div className="form-group">
                                    <input className="form-control" id="size" placeholder="Numero" />
                                </div>
                            </div>
                        </div>

                        <div className="form-group">
                            <button className="btn btn-primary" onClick={this.products}>Rechercher</button>
                        </div>


                    </div>

                    <div className="card card-default mt-2 bg-primary text-white">



                        <div className="card-body">
                            <div className="row">
                                <div className="col-md-3">Description</div>
                                <div className="col">Quantité</div>

                                <div className="col">Type</div>

                                <div className="col">Date</div>
                            </div>
                        </div>

                    </div>

                    {productList.length > 0 && productList.map(product => {

                        index++;

                        let type = '';

                        if(product.type == 'ADD'){

                            type = 'AJOUT STOCK';
                        }else if(product.type == 'RETURN'){

                            type = 'SUPPRESSION';
                        }else if(product.type == 'ORDER'){

                            type = 'COMMANDE';
                        }

                     return <div className="card card-default mt-2" key={index}>

                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">{product.name} {product.model} {product.brand} {product.color} {product.size} </div>
                                    <div className="col" id={"prod-qty-" + product.id}>{product.quantity}</div>
                                    <div className="col">
                                       <span className="text-danger"> { type }</span>
                                    </div>

                                    <div className="col">
                                        { product.dateString }
                                    </div>

                                </div>
                            </div>

                        </div>
    })}

                </div>
            </div>



        );

    }

}

export default StockProductProductTransactions;